import { useIsMobile } from 'WindowDimensionProvider';
import { DEFAULT_MOBILE_GRID, DEFAULT_RESULTS_GRID } from '../consts';

export const useGridConfig = () => {
  const isMobile = useIsMobile();

  if (isMobile) return DEFAULT_MOBILE_GRID;

  return DEFAULT_RESULTS_GRID;
};
